module.exports = __webpack_public_path__ + "static/media/motor-products.404ec68f.png";